var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-contain"},[_c('img',{attrs:{"src":(_vm.site + "/" + _vm.val),"height":"200"}}),_c('span',{on:{"click":function($event){return _vm.clear()}}},[_c('IconClear')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }